<a href="/">
  <h1>
    <span >{window.gettext('Yale')}</span>
    <span class="serif">{window.gettext('Framework')}</span>
  </h1>
  <p>
    {window.gettext('Integrating Climate Adaptation and Landscape Conservation Planning')}
  </p>
</a>

<style lang="scss">
  a {
    color: $blue-2;
    font-weight: 700;
    text-decoration: none;
    margin: 19px 0 0 19px;
    display: block;

    h1 {
      font-family: Baskerville, "Baskerville Old Face", "Hoefler Text", "Times New Roman", serif;
      font-size: $font-size-5;
      margin-bottom: 2px;

      .serif {
        font-style: italic;
        color: #acc0d3;
        font-size: $font-size-4;
      }
    }

    p {
      font-size: 12px;
      text-transform: uppercase;
    }

    &:hover {
      text-decoration: none;
    }
  }
</style>
